<template>
  <div id="app" @mousemove="resetSessionTimer()" @click="resetSessionTimer()" @keydown="resetSessionTimer()">
    <appHeader v-if="$route.path != '/'" ref="head"/>
    <router-view/>
    <p class="copyright" v-if="$route.path != '/'">Copyright &copy; 2019 Gutenberg Networks Warszawa Sp. z o.o.</p>
    <div class="footer" v-if="$route.path == '/'">
      <p>Copyright &copy; 2019 Gutenberg Networks Warszawa Sp. z o.o.</p>
      <div class="logo">
        <img class="logo__gutenberg" src="@/assets/images/Gutenberg_logo_Poziom_RGB.png" alt="" />
        <img class="logo__gutenberg" src="@/assets/images/NETKATALOG 2.0.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import router from './router';
import appHeader from '@/components/appHeader.vue';


export default {
  name: 'app',
  components: {

    appHeader,

  },
  router,
  data(){

    return{

      role: '',

    }

  },
  methods:{

    resetSessionTimer(){

      if(this.$route.path != '/' && this.$route.path != '/user/password'){

        this.$refs.head.refreshSession();
        
      }

    },

    translate(txt){

      let dictionary =[
        {origin: 'ROLE_LOCAL', translate: 'Lokalne'},
        {origin: 'ROLE_CENTRAL', translate: 'Centralne'},
        {origin: 'ROLE_COORDINATOR', translate: 'Koordynator'},
        {origin: 'ROLE_EDITOR', translate: 'Edytor'},
        {origin: 'ROLE_SUPER_ADMIN', translate: 'Admin'},
        {origin: 'ROLE_ADMIN', translate: 'Admin'},
      ];

      let obj = dictionary.find(o => o.origin === txt);
      
      if(obj){

        return obj.translate;

      }

      return txt;

    },

    getUserRole(){

      if(localStorage.getItem('role') != null){

        this.role = localStorage.getItem('role');

      }

    },

    checkRole(){

      return this.role;

    },

    grantPermission(table){

      for (var value of table) {
        
        if(this.role == value){

          return true;

        }

      }

      return false;

    },

    uncheckAllCheckboxes(){

      var checks = document.querySelectorAll('input[type="checkbox"]');
      for(var i =0; i< checks.length;i++){
          var check = checks[i];
          if(!check.classList.contains('isHeroCheck')){
            if(!check.disabled){
                check.checked = false;
            }
          }
      }

    },

  },
  mounted(){

    this.getUserRole();

  }
};
</script>

<style lang="scss">

@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,600,700&subset=latin-ext');

$mediared: #e3000b;
$buttonNormal: #939393;

#app{
  overflow-x: hidden;
}

.vue-input {
  background-color: transparent !important;
  border: none !important;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none !important;
  outline-style: none !important;
  padding: 0px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 300;
  font-size: 18px;
  color: #000000;
  opacity: 1;
  height: auto;
  padding-left: 0 !important;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.view-data{
  width: 100%;
  transition: 0.3s ease;

  &__header{
    border-bottom: 2px $mediared solid;
    padding-top:20px;
    margin-bottom: 30px;

    & h1{
      font-size: 18px;
    }
  }
}

.view-body--module{
    padding:0% 1%;
}


.data-header{
  display:flex;
}

.single-table-header{
  margin:0;
  cursor:pointer;
}


.view-data.body-wide, .copyright.body-wide{
    width: calc(100% - 70px);
    transition: 0.3s ease;
}

.error {
  display: none;
}
.has-error .error {
  display: block;
}

.select-link{
  cursor:pointer;
  text-decoration: underline;
}

.form{
  width:50%;
  padding: 10px;
  margin-bottom: 5%;

  &__tabs{
    display:grid;
    width:100%;
    padding: 0% 10%;
    margin-bottom: 30px;
    grid-template-columns: 33.333% 33.333% 33.333%;
    text-align: center;
  }

  &__tabs-view{
    width:100%;
    min-height: 628px;
  }

  &__tabs-pagination{
    display:flex;
    justify-content: space-between;
    width:40%;

    & span{
      display:flex;
      align-items: center;
      cursor:pointer;
    }
  }

  &--password{
    width:30%;
  }
}

.tab{
  text-align: center;
  border-bottom: 1px #d3dfef solid;
  padding:20px 0px;
  cursor:pointer;
  text-transform: uppercase;

  &.active{
    color:#000;
    border-bottom: 1px #000 solid;
  }
}

.list-group--form{
  max-height: 380px;
  background:#fff;
  width:92%;
  overflow: hidden;
  overflow-y: scroll;
  position: absolute;
}

.form-footer{
  display:flex;
  width:100%;
  justify-content: space-between;
  align-items: baseline;
  padding: 2% 0%;

  &--single{
    justify-content: flex-end;
  }
}

.form-control, select{
  border:none;
  box-shadow: none;
  border-radius: 0px;
  background:none;
  border-bottom: 1px #d3dfef solid;
}

select {
  padding: 2px 5px;
  padding-right: 15px;
  line-height: 1;
  background: url('assets/symbols/arrow-down.svg') no-repeat right !important;
  appearance:none !important;
  -moz-appearance:none !important;
  -webkit-appearance:none !important;

  &.white {
    background: url('assets/symbols/arrow-down--white.svg') no-repeat right !important;
  }
}

.search{
  padding-right:25px;
}

.form-group{
  width:100%;

  &__icon{
    float:right;
    margin-top:-3rem;
    opacity:0.3;
  }

  & > input, select{
    box-shadow: none;
    outline:none !important;
    outline-style: none !important;
    padding:0px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 300;
    font-size: 18px;
    color: #000000;
    opacity: 1;
    height:auto;
    transition: all 0.2s ease;
  }

  & > label{
    color:#3E4A59;
    font-size: 12px;
    opacity: 0.7;
  }
}

.form-group.input-error > input, .form-group.input-error  .vs__dropdown-toggle{
  border-bottom: 2px $mediared solid !important;
  padding-bottom:18px;
  transition: all 0.2s ease;
  height: 47px;
}

.form-group.input-error > input, .form-group.input-error  .vs__search{
  height: 47px;
}

.form-group.input-error  .vs__actions{
  display:none;
}

.form-group.input-error  > img{
  display:none;
}

.form-group.input-error .input-col > img{
  display:none;
}

.form-group.input-error > .input-row > .input-col > input{
  border-bottom: 2px $mediared solid;
  padding-bottom:18px;
  transition: all 0.2s ease;
}

.form-group.input-success > input{
  border-bottom: 2px #30DA51 solid;
  padding-bottom:18px;
  transition: all 0.2s ease;
}

.form-group input:focus, .form-group select:focus{
  box-shadow: none !important;
}

.form-group input:focus{
  background:none !important;
}

.form-group .row{
  width: 100% !important;
  margin: 0 !important;
}

[type="date"] {
  background: none;
  box-sizing: border-box;
  position:relative;
  padding: 0;
}
[type="date"]::-webkit-inner-spin-button {
  display: none;
}
[type="date"]::-webkit-calendar-picker-indicator {
  background: transparent;
    bottom: 0;
    color: transparent;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
    //z-index: 1;
    //display:none !important;
}

input::-webkit-clear-button {
  background: transparent;
    bottom: 5px;
    right:0;
    cursor: pointer;
    height: auto;
    position: absolute;
    width: 10%;
    z-index: 20000 !important;
    display:none !important;
}



label{
  font-weight: 400;
  color:#3e4a59;
}

.col--center-flex{
  display:flex;
  align-items: center;
  justify-content: center;
  padding:0px 5px;
}

input[type=checkbox],
input[type=radio]{
  margin:0px 5px;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkbox, .radio {
  display: flex;
  align-items: center;
  margin:0;
  padding:0 5px;
  white-space: nowrap;
  font-weight: 300;

  &--form{
    display:block;

    & > .checkmark{
      margin:0px;
      border-radius: 3px;
      border:1px rgb(207, 207, 207) solid;
    }
  }
}

.radio {
  display: inline-flex;
  opacity: 1 !important;
  color: #181f27 !important;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}

.checkmark {
  position: relative;
  display:flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  margin: 0 5px;
  height: 15px;
  width: 15px;
  background-color: #fff;
  border-radius: 3px;
  border:1px rgb(207, 207, 207) solid;
}

.radio .checkmark {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #000000;
  background-color: #ffffff;
  box-shadow: inset 0 2px 1px rgba(0, 0, 0, 0.06);
}

.radio:hover input ~ .checkmark {
  background-color: #eee;
}

.radio input:checked ~ .checkmark {
  background-color: #fff;
}

.radio:after {
  content: "";
  position: absolute;
  display: none;
  color: #d3020c;
  
}

/* Show the checkmark when checked */
.radio input:checked ~ .checkmark:after {
  display: block;
}

.radio .checkmark:after {
  width: 6px;
  height: 6px;
  background-color: #000000;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.checkbox:hover input ~ .checkmark {
  background-color: #eee;
}

.checkbox input:checked ~ .checkmark {
  background-color: #fff;
}



.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  color:#d3020c;
}

/* Show the checkmark when checked */
.checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox .checkmark:after {
  width: 5px;
  top: 1px;
  left: 4px;
  height: 10px;
  border: solid #d3020c;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}


.pagination{
  margin: 20px 0px !important;
}

.pagination > li > a{
    background-color: #fff !important;
    color: $mediared !important;
    border-color: $mediared !important;
}

.pagination > .active > a{
    color: $mediared !important;
    background-color:transparent !important;
    border: solid 1px $mediared !important;
    font-weight: 700 !important;
    outline: none !important;
    box-shadow: none !important;
}

.pagination > .disabled > span{
    color: $mediared !important;
    background-color:transparent !important;
    border: solid 1px $mediared !important;
}

.pagination > li > a:focus,
.pagination > li > a:hover,
.pagination > li > span:focus,
.pagination > li > span:hover,
.pagination > .active > a:hover{
    background-color: $mediared !important;
    color: #fff !important;
}

.badge{
  width:100%;
  padding: 1rem 0.2rem;
  text-transform: uppercase;
  font-weight: 400;

  &--sign{
    padding: 1rem 1rem;
  }
}

.badge-red{
  background:$mediared;
}

.badge-yellow{
  background: #F9AC3D;
}

.badge-navy{
  background: #2D758C;
}

.badge-green{
  background: #758C33;
}

.badge-light-grey{
  background: #ACACAC;
}

.badge-dark-grey{
  background: #555555;
}

// @todo: utworzyc plik scss do listy select2 i przenieśc stylowanie
.vs--open .vs__open-indicator {
  transform: rotate(180deg) scale(0.7) !important;
}
.select--list {

  .vs__dropdown-toggle {

    border-radius: 0px;
    border: none;
    border-bottom: 1px #d3dfef solid !important;

  }

  .vs__search {
    position: absolute;
    width:100%;
  }

  .vs__actions button,
  .vs__actions svg {
    display: inline;
  }

  .vs__actions svg {
    display: inline !important;
  }

  .vs__open-indicator {
    transform: scale(0.7);
  }

  &.white {
    .vs__open-indicator {
      fill: #ffffff;
    }
  }

  .vs--open .vs__dropdown-toggle {
    border-bottom-color: #d3dfef;
  }

  .vs__dropdown-menu {
    top: calc(100% + 1px) !important;
    margin-top: 2px !important;
    border: none;
    max-height: 160px;
    padding: 3px 2px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  .vs__dropdown-option {
    line-height: 1.42857143;
    display: block;
    position: relative !important;
    min-height: 20px !important;
    padding: 10.5px 17px;
    clear: both;
    white-space: normal; //tekst powinien się jednak łamać
    color: #939393;
    font-size: 14px;

    line-height: 15px;
    border: 1px solid transparent;

    &:nth-of-type(even) {
      border: 1px solid #d3dfef;
      background-color: #f2f5f7;

    }

    &.vs__dropdown-option--highlight {
      background-color: #f0f9ff;
    }
    
  }

  .vs__actions {
    display: block !important;
    min-width: 46px;
    text-align: right;
  }

  .vs__selected {
    color: #000000 !important;
    opacity: 1 !important;
  }

  .vs__dropdown-option:hover {
    cursor: pointer;
  }

  .vs__dropdown-option--highlight {
    background: #ffffff;
    color: #939393;
  }

}

.history-select{

  .vs__actions {
    min-width:auto !important;
  }

  .vs__dropdown-menu {
    max-height:600px !important;
  }
}

.page-select{

  .vs__actions {
    min-width:auto !important;
  }

  .vs__search{
    width:100% !important;
    padding:0 !important;
  }

  .vs__dropdown-menu {
    max-height:190px !important;
  }
}

// @todo: przenieść do core - stylowanie scroll bar'a
.vs__dropdown-menu::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.vs__dropdown-menu::-webkit-scrollbar-track {
  background-color: rgba(226,229,235, 0.5);
  border-radius: 2px;
}

.vs__dropdown-menu::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: rgba(177,180,193, 0.5);
}

.vs__selected-options{
  padding-left: 0 !important;
}

.vs__selected-options .vs__selected{
  padding-left: 0 !important;
  margin-left: 0 !important;
  font-size: 18px;
  opacity:0.7;

  @media (max-width: 1400px){
    margin-top:-5px;
  }

}

.market-select{

  white-space: nowrap;

  & .vs__dropdown-toggle{
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    max-width: 100%;
    height: 2em;

    & .vs__selected-options{
    position: absolute;
    width: 100%;
    }

    & .vs__selected{
      position: relative;
      width: 79%;
      overflow: hidden;
    }

    & .vs__actions{
      margin-left:80%;
      opacity: 0;
    }
  }

  & .vs__dropdown-menu{
    width:150%;
  }
}

input[type=time]::-webkit-inner-spin-button, 
input[type=time]::-webkit-outer-spin-button { 
    transform: rotate(180deg);
}

.image-info-content {

  background: #ffffff;
  color: #000000; 
  font-size: 12px; 
  letter-spacing: 0.06px; 
  line-height: 15px;
  text-align: left;
  margin-left: -20px;
  margin-top: 10px;

  min-height: 30px;
  border-radius: 8px;
  padding: 5px;
  width: 170px;

  display: none;

  @media (min-width: 1600px) {
    font-size: 12px; 
    width: 180px;
  }

}

.disabled{
  pointer-events: none !important;
}

.search__image--item {
  position: relative;
  float: left;
  width: 48%;
  max-width: 200px;
  min-height: 140px;
  margin-right: 4%;
  margin-bottom: 24px;
  border: 1px solid #0E0E0E;

  @media (max-width: 1400px) {
    width: 100%;
    margin-right: 0;
  }

  &:nth-of-type(even) {
    margin-right: 0;
  }

  .name {
    position: absolute;
    bottom: -9px;
    left: -7px;
    color: #000000; 
    font-size: 7px; 
    letter-spacing: 0.07px; 
    line-height: 17px;
    padding: 0px 10px;
    background-color: #ffffff;
    border-radius: 5px;
    min-width: 70%;
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 90%;
    max-height: 90%;
  }

  .not-accepted {
    position: absolute;
    top: -5px;
    right: -7px;
    width: 14px;
    height: 14px;
    color: #ffffff;
    font-size: 10px;
    line-height: 15px;
    font-weight: 500;
    border-radius: 50%;
    text-align: center;
    cursor: pointer;
    background-color: #E3000A;
  }

  .info {
    position: absolute;
    z-index: 1090;
    top: -5px;
    left: -7px;
    width: 14px;
    height: 14px;
    color: #ffffff;
    font-size: 10px;
    line-height: 13px;
    font-weight: 500;
    border-radius: 50%;
    text-align: center;

    cursor: pointer;
    background-color: #5CA6FF;

    &:hover {
      .image-info-content {
        position: absolute;
        z-index: 1000;
        display: block;
      }
    }
  }
}

.image__quality--not-accepted {
  position: absolute;
  top: -5px;
  right: -7px;
  width: 14px;
  height: 14px;
  color: #ffffff;
  font-size: 10px;
  line-height: 15px;
  font-weight: 500;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
  background-color: #E3000A;
}

.small-icon-list-element {

  position: relative;
  height: 70px;
  width: 47%;
  vertical-align: top;
  border: 1px solid #979797;
  background-color: #FFFFFF;
  margin-right: 5%;
  margin-bottom: 11px;

  &:nth-of-type(even) {
    margin-right: 0;
  }

  .name {
    position: absolute;
    bottom: -9px;
    left: -7px;
    color: #000000; 
    font-size: 7px; 
    letter-spacing: 0.07px; 
    line-height: 17px;
    padding: 0px 10px;
    background-color: #ffffff;
    border-radius: 5px;
    min-width: 70%;
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 90%;
    max-height: 90%;
  }

  .not-accepted {
    position: absolute;
    top: -5px;
    right: -7px;
    width: 14px;
    height: 14px;
    color: #ffffff;
    font-size: 10px;
    line-height: 15px;
    font-weight: 500;
    border-radius: 50%;
    text-align: center;
    cursor: pointer;
    background-color: #E3000A;
  }

  .info {
    position: absolute;
    z-index: 1090;
    top: -5px;
    left: -7px;
    width: 14px;
    height: 14px;
    color: #ffffff;
    font-size: 10px;
    line-height: 13px;
    font-weight: 500;
    border-radius: 50%;
    text-align: center;

    cursor: pointer;
    background-color: #5CA6FF;

    &:hover {
      .image-info-content {
        position: absolute;
        z-index: 1000;
        display: block;
      }
    }
  }

}

.order-tooltip{
  position:absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height:24px;
  padding: 0px 5px;
  font-size: 10px;
  top:0px;
  margin-top:-23px;
  right:-35px;
  text-transform: initial;
  background:#E3E4E4;
  color:#7F8FA4;
  visibility: hidden;
  z-index: 100;

  &--edit{
    right: -25px;
  }
}

.name--zoom {
  width: 14px;
  height: 14px;
  background-color: #E3000A;
  position: absolute;
  top: -14px;
  cursor: pointer;
  left: 0;
  z-index: 100;

  &.name--zoom-alone {
    bottom: -3px;
    left: -3px;
    top: auto;
  }

}

.files-list{
 margin:10px 0px;
 padding: 0;

  & li{
    display:flex;
    justify-content: space-between;
    align-items: center;
    list-style: none;
    padding: 5px 0px;

    & span{
      width:5%;

      & img{
        width:100%;
      }
    }

    & .button-group{
      width:92%;
    }

    & .delete-file{
        margin-left: 5px;
        width:20px;
        height:20px;
        visibility: hidden;
    }

    & p{
      display:flex;
      margin:0;
      word-break: break-all;
      cursor:default;
      max-width:90%
    }

    &:hover .delete-file{
        visibility: visible;
    }

  }

}

select::-ms-expand {
    display: none;
}

</style>